import { requst } from '../config'

// 日历上数据
export const getConsumableCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/consumable/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getConsumableDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getConsumableByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/consumable/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getConsumableByIdApi = id => {
    const url = `/monitor/consumable/${id}`
    return requst.get(url)
}

// 获取标准数据
export const getConsumableSumDataApi = id => {
    const url = `/monitor/consumable/standard/list?consumableId=${id}`
    return requst.get(url)
}

// 提交消耗品 总结
export const postConsumableCommentApi = commentData => {
    const url = `/monitor/consumable`
    return requst.post(url, { ...commentData })
}

// 修改消耗品 总结
export const putConsumableCommentApi = (commentData, id) => {
    const url = `/monitor/consumable`
    return requst.put(url, { ...commentData, id })
}

// 提交标准消耗品
export const postConsumableSumDataApi = (consumableSumParams, id) => {
    const url = `/monitor/consumable/standard/addOrUpdateBatch/${id}`
    return requst.post(url, consumableSumParams)
}

// 提交标准消耗品
export const postConsumableSumAllDataApi = (id, locationId, date) => {
    const url = `/monitor/consumable/standard/getStandardConsumableSummary?projectId=${id}&locationId=${locationId}&endDate=${date}`
    return requst.get(url)
}
